var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28 20h-2.351a3.495 3.495 0 00-3.15-2 3.493 3.493 0 00-3.147 2h-7.703a3.495 3.495 0 00-3.15-2 3.493 3.493 0 00-3.147 2H4v-4h24v4zm-5.5 3a1.497 1.497 0 01-1.408-1 1.483 1.483 0 01-.092-.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5c0 .176-.036.343-.092.5-.207.581-.757 1-1.408 1zm-14 0a1.497 1.497 0 01-1.408-1A1.483 1.483 0 017 21.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5c0 .176-.036.343-.092.5-.207.581-.757 1-1.408 1zm4.035-13H18v2.055h2V10h2.279l1.333 4H9.868l2.667-4zM29 14h-3.28l-1.772-5.316A.997.997 0 0023 8H12c-.334 0-.646.167-.832.445L7.465 14H3a1 1 0 00-1 1v6a1 1 0 001 1h2.05c.246 1.692 1.69 3 3.45 3 1.759 0 3.204-1.308 3.449-3h7.102c.245 1.692 1.69 3 3.449 3s3.204-1.308 3.449-3h3.05a1 1 0 001-1v-6a1 1 0 00-1-1z",
    fill: props.color
  })));
}

export default SvgIconCar;